<template>
  <div class="progress-wrap">
    <div class="progress-item">
      <div v-if="step === 1" class="circle">1</div> 
      <div v-else class="circle done">
        <i class="fa-solid fa-check"/>
      </div>
      <div 
        class="content"
        :class="step === 1 ? 'current' : ''"
      >
        {{ textOne }}
      </div>
    </div>
    <div class="progress-item">
      <div v-if="step === 2" class="circle">2</div>
      <div v-else-if="step === 3 || step === 4" class="circle done">
        <i class="fa-solid fa-check"/>
      </div>
      <div v-else class="circle undone">2</div>
      <div 
        class="content"
        :class="step === 2 ? 'current' : ''"
      >
        {{ textTwo }}
      </div>
    </div>
    <div class="progress-item">
      <div v-if="step === 3" class="circle">3</div>
      <div v-else-if="step === 4" class="circle done">
        <i class="fa-solid fa-check"/>
      </div>
      <div v-else class="circle undone">3</div>
      <div 
        class="content"
        :class="step === 3 ? 'current' : ''"
      >
        {{ textThree }}
      </div>
    </div>
    <div class="progress-item">
      <div v-if="step === 4" class="circle">4</div>
      <div v-else class="circle undone">4</div>
      <div 
        class="content"
        :class="step === 4 ? 'current' : ''"
      >
        {{ textFour }}
      </div>
    </div>
    <div class="progress-line-wrap">
      <div 
        class="progress-line"
        :class="step > 1 ? 'done' : 'undone'"
      />
      <div 
        class="progress-line"
        :class="step > 2 ? 'done' : 'undone'"
      />
      <div 
        class="progress-line"
        :class="step > 3 ? 'done' : 'undone'"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressWrapFour',
  props: {
    step: {
      type: Number,
      required: true
    },
    progressTexts: {
      type: Array,
      required: true
    }
  },
  computed: {
    textOne() {
      if (!Array.isArray(this.progressTexts)) return '';
      return this.progressTexts[0] || '';
    },
    textTwo() {
      if (!Array.isArray(this.progressTexts)) return '';
      return this.progressTexts[1] || '';
    },
    textThree() {
      if (!Array.isArray(this.progressTexts)) return '';
      return this.progressTexts[2] || '';
    },
    textFour() {
      if (!Array.isArray(this.progressTexts)) return '';
      return this.progressTexts[3] || '';
    }
  }
}
</script>

<style lang="scss" scoped>
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100: #17191C;
$Gray-70: #6e747c;
$Gray-60: #8D939A;
$Gray-30: #DDE0E4;
$Gray-50: #ACB2B9;
$Gray-10: #F1F2F3;
$Gray-5: #F7F8F8;
$Yellow: #ffe414;
$Blue: #278AEC;

.progress-wrap {
  width: 100%;
  display: flex;
  gap: 0px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 0 20px 4px;
  position: relative;
  margin-bottom: 24px;

  .progress-item {
    z-index: 2;
    display: flex;
    flex: 1 0 0px;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 12px;
    height: min-content;
    justify-content: center;
    overflow: visible;
    padding: 0;
    position: relative;
    flex-basis: auto;
    width: auto;

    .circle {
      align-items: center;
      aspect-ratio: 1 / 1;
      background-color: #fff;
      border-radius: 100%;
      box-shadow: 0 0 0 4px #ffe4144d, 0 0 0 2px #ffe414;
      display: flex;
      flex: none;
      flex-direction: row;
      flex-wrap: nowrap;
      gap: 10px;
      height: var(--framer-aspect-ratio-supported, 36px);
      justify-content: center;
      overflow: hidden;
      padding: 0;
      position: relative;
      width: 36px;
      margin: 0 auto;
      font-weight: 600;
      font-size: 14px;
      color: $Gray-90;
    }

    .circle.done {
      background-color: $Yellow;
      box-shadow: none;
      color: $Gray-90;

      i {
        font-size: 13px;
        color: $Gray-90;
      }
    }

    .circle.undone {
      background-color: #fff;
      border: 1px solid $Gray-30;
      box-shadow: none;
      color: $Gray-50;
    }

    .content {
      outline: none;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex-shrink: 0;
      transform: none;
      font-size: 14px;
      margin: 0 auto;
      color: $Gray-70;
      text-align: center;
      font-weight: 400;
    }

    .content.current {
      color: $Gray-100;
      font-weight: 600;
    }
  }

  .progress-line-wrap {
    position: absolute;
    width: 71%;
    top: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    left: 49%;
    transform: translateX(-50%);

    .progress-line {
      width: 32%;
      height: 4px;
    }

    .progress-line.undone {
      background-color: $Gray-30;
    }

    .progress-line.done {
      background-color: $Yellow;
    }
  }
}

// 반응형 디자인
@media (max-width: 768px) {
  .progress-wrap {
    padding: 0 10px 4px;

    .progress-item {
      .circle {
        width: 32px;
        height: 32px;
        font-size: 12px;

        i {
          font-size: 11px;
        }
      }

      .content {
        font-size: 12px;
      }
    }

    .progress-line-wrap {
      top: 16px;

      .progress-line {
        height: 3px;
      }
    }
  }
}
</style>
